
// Vue reactivity
import { defineComponent } from 'vue';

// icons
import { close } from 'ionicons/icons';

// components
import { IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonButton, IonIcon,
        IonRow, IonCol, IonSlides, IonSlide, modalController } from '@ionic/vue';

export default defineComponent({
  name: 'CoachModal',
  props: {
    coach: {}
  },
  components: { IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonButton, IonIcon,
                IonRow, IonCol, IonSlides, IonSlide, },
  setup() {
    const closeModal = async () => { await modalController.dismiss() };

    // 3. return variables & methods to be used in template HTML
    return {
      // icons
      close,

      // variables
      
      // methods
      closeModal,
    }
  }
});
